// data validated in AEM
import { UeReference } from '@oneaudi/falcon-tools';
import { bool, number, shape, string } from 'prop-types';
import React, { useContext } from 'react';

import { StyledContentTileContainer } from '../ContentTiles/styles';
import { TileSizes } from '../ContentTiles/tileSizes';
import { handleSetTileHeights, setMobileTileHeights, setTileHeights } from '../ContentTiles/utils';

import { ContentTile } from './Component';
import {
  getClickEvent,
  getClickEventAction,
  getSanitizedUrl,
} from '../../../tracking/getClickEvent';
import { useTrackingService } from '../../hooks/useTrackingService';

// 🔥 [E] 👇
import { ContentContext } from '../../context/ContentContext';
import { getClickEvent as pctGetClickEvent } from '../../__ember__personalization/analytics/getClickEvent';
// 🔥 [E] ☝️

export function ContentTileContainer({
  index,
  tileData,
  setSize,
  setTileHeightsDirectly,
  leadCardIndex,
  layoutName,
  layoutSize,
  width,
  isTest,
}) {
  // 🔥 [E] 👇
  const context = useContext(ContentContext);
  const { isPersonalized, isInContentTileMode } = context;
  // 🔥 [E] ☝️

  const { trackingService } = useTrackingService();
  const onTileClick = (e) => {
    if (trackingService) {
      const sanitizedUrl = getSanitizedUrl(trackingService, tileData);
      const eventAction = getClickEventAction(trackingService, sanitizedUrl);

      // 🔥 [E] 👇
      // const event = getClickEvent(eventAction, sanitizedUrl, tileData, index);
      const event = isInContentTileMode
        ? getClickEvent(eventAction, sanitizedUrl, tileData, index)
        : pctGetClickEvent(eventAction, sanitizedUrl, tileData, index, isPersonalized);
      // 🔥 [E] ☝️

      trackingService.track({ event });
      e.stopPropagation();
    }
  };
  return (
    <StyledContentTileContainer width={width} layout={layoutName}>
      <UeReference key={index} propertyPath={`tiles.${index}`} behavior="component">
        {(ueProps) => {
          return (
            <ContentTile
              key={index}
              index={index}
              layoutName={layoutName}
              {...tileData}
              size={
                setSize && !setTileHeightsDirectly
                  ? handleSetTileHeights(index, layoutName, layoutSize)
                  : setSize && setTileHeightsDirectly
                    ? setTileHeights(TileSizes[layoutName].sizeTwo[layoutSize])
                    : null
              }
              mobileBreakpointSizes={{
                s: setMobileTileHeights(
                  index,
                  leadCardIndex,
                  '375 breakpoint',
                  layoutSize,
                  layoutName,
                ),
                m: setMobileTileHeights(
                  index,
                  leadCardIndex,
                  '768 breakpoint',
                  layoutSize,
                  layoutName,
                ),
              }}
              onClickEvent={onTileClick}
              isTest={isTest}
              {...ueProps}
            />
          );
        }}
      </UeReference>
    </StyledContentTileContainer>
  );
}

ContentTileContainer.displayName = 'ContentTileContainer';
